import { render, staticRenderFns } from "./BadgerAccordionItem.vue?vue&type=template&id=5b85a609&"
import script from "./BadgerAccordionItem.vue?vue&type=script&lang=js&"
export * from "./BadgerAccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./BadgerAccordionItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports